import React from 'react'
import { Line } from 'react-chartjs-2'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import styled from 'styled-components'

import { BlueBox, NoResults } from '../common'
import { Padding } from '../../../..'
import { colors } from '../../../../../constants'

const Header = styled.div`
    height: 30px;
`

const ChartContainer = styled.div`
    height: calc(100% - 30px);
    margin: 0;
    padding: 0 10px;
    width: 100%;
`

const OverallInteractions = ({ data, isEmpty, labels, loading, t }) => (
    <BlueBox loading={loading} noResults={isEmpty}>
        <Padding top bottom fullHeight>
            <Header>
                <Padding left>{t('Overall Interactions')}</Padding>
            </Header>
            {isEmpty && <NoResults />}
            {!isEmpty && (
                <ChartContainer>
                    <Line
                        data={{
                            labels,
                            datasets: [
                                {
                                    backgroundColor: 'transparent',
                                    borderColor: colors.bluelight,
                                    borderWidth: 7,
                                    data,
                                    lineTension: 0,
                                    pointRadius: 1,
                                    datalabels: {
                                        display: false,
                                    },
                                },
                            ],
                        }}
                        options={{
                            bezierCurve: false,
                            datasetFill: false,
                            legend: {
                                display: false,
                            },
                            maintainAspectRatio: false,
                            scales: {
                                xAxes: [
                                    {
                                        gridLines: {
                                            color: 'transparent',
                                        },
                                        ticks: {
                                            fontColor: colors.white,
                                        },
                                    },
                                ],
                                yAxes: [
                                    {
                                        gridLines: {
                                            color: colors.bluedark,
                                        },
                                        ticks: {
                                            display: true,
                                            fontColor: colors.white,
                                        },
                                    },
                                ],
                            },
                        }}
                    />
                </ChartContainer>
            )}
        </Padding>
    </BlueBox>
)

OverallInteractions.propTypes = {
    data: PropTypes.arrayOf(PropTypes.number),
    isEmpty: PropTypes.bool,
    labels: PropTypes.arrayOf(PropTypes.string),
    loading: PropTypes.number,
    t: PropTypes.func.isRequired,
}

OverallInteractions.defaultProps = {
    data: [],
    isEmpty: true,
    labels: [],
    loading: null,
}

export default withTranslation()(OverallInteractions)
